<div class="position-relative">
    <label *ngIf="label"
           [ngClass]="labelClasses">
        {{label | translate}}
    </label>
    <ng-content></ng-content>
</div>
<div class="input-group datepicker-wrapper"
     [ngClass]="inputWrapperClasses">
    <input class="form-control"
           placeholder="yyyy-mm-dd"
           name="dp"
           ngbDatepicker
           [disabled]="disabled"
           [readonly]="readonly"
           [(ngModel)]="date"
           (ngModelChange)="onChange($event)"
           (blur)="onBlur($event)"/>

    <button type="button"
            class="btn btn-outline-secondary"
            [disabled]="disabled || readonly"
            (click)="toggle()">
        <i class="material-icons">date_range</i>
    </button>
</div>
